import { getChannel } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRChannel = (channelId: string | null) => {
  const {
    data: channel,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(channelId ? `channel-${channelId}` : null, () => getChannel(channelId as string));

  return {
    channel,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRChannel;
